module.exports = __webpack_public_path__ + "img/NODE_CROSS.a752e712.svg";